import { UPDATE_USER,UPDATE_PASSWORD_SETTINGS } from "./types";

export const userAccessConfiguration = (value) => async (dispatch) => {
    await dispatch({
        type: UPDATE_USER,
        payload: value
    });
};

export const userPasswordConfiguartion = (value) => async (dispatch) => {
    await dispatch({
        type: UPDATE_PASSWORD_SETTINGS,
        payload: value
    });
};